export default __webpack_public_path__ + "static/media/americano.feed4d5e.png";